// Author YuJiaBei
// Date 2023-11-27 15:20:01

class EmMenu {
constructor({
        id = null,
        parentId = '',
        name = '',
        menuTypeCode = '',
        crudCode = '',
        i18nMenuName = '',
        i18nBreadcrumbName = '',
        url = '',
        baseRequestUrl = '',
        aclUrl = '',
        workflowDefinitionKey = '',
        workflowName = '',
        iconCode = '',
        seq = '',
        status = '',
                remark = '',
                customConfigJson = ''
            }
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.menuTypeCode = menuTypeCode;
    this.crudCode = crudCode;
    this.i18nMenuName = i18nMenuName;
    this.i18nBreadcrumbName = i18nBreadcrumbName;
    this.url = url;
    this.baseRequestUrl = baseRequestUrl;
    this.aclUrl = aclUrl;
    this.workflowDefinitionKey = workflowDefinitionKey;
    this.workflowName = workflowName;
    this.iconCode = iconCode;
    this.seq = seq;
    this.status = status;
    this.remark = remark;
    this.customConfigJson = customConfigJson;
}
}

function newEntity() {
return new EmMenu();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'parentName',
        label: 'label.em.admin.emMenu.grid.parentName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'level',
        label: 'label.em.admin.emMenu.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emMenu.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'menuTypeName',
        label: 'label.em.admin.emMenu.grid.menuTypeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'crudName',
        label: 'label.em.admin.emMenu.grid.crudName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'url',
        label: 'label.em.admin.emMenu.grid.url',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'baseRequestUrl',
        label: 'label.em.admin.emMenu.grid.baseRequestUrl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'aclUrl',
        label: 'label.em.admin.emMenu.grid.aclUrl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'workflowName',
        label: 'label.em.admin.emMenu.grid.workflowName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emMenu.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'i18nMenuName',
        label: 'label.em.admin.emMenu.grid.i18nMenuName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'i18nBreadcrumbName',
        label: 'label.em.admin.emMenu.grid.i18nBreadcrumbName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'iconName',
        label: 'label.em.admin.emMenu.grid.iconName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'status',
        label: 'label.em.admin.emMenu.grid.status',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' }
            ]
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emMenu.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
            key: 'customConfigJson',
            label: 'label.em.admin.emMenu.grid.customConfigJson',
            sortable: true,
            form: {
                type: 'json-params',
                modalMultiSelectedType: 'string'
            }
        }
    ])}

const filter = {
    idFilter : '',
    parentIdFilter : '',
    nameFilter : '',
    menuTypeCodeFilter : '',
    levelFilter : '',
    urlFilter : '',
    baseRequestUrlFilter : '',
    aclUrlFilter : '',
    workflowDefinitionKeyFilter : '',
    workflowNameFilter : '',
    crudCodeFilter : '',
    iconCodeFilter : '',
    statusFilter: '',
    customConfigJsonFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentIdFilter',
        label: 'label.em.admin.emMenu.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emMenu'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emMenu.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'menuTypeCodeFilter',
        label: 'label.em.admin.emMenu.filter.menuTypeCode',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emMenuType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'urlFilter',
        label: 'label.em.admin.emMenu.filter.url',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baseRequestUrlFilter',
        label: 'label.em.admin.emMenu.filter.baseRequestUrl',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'aclUrlFilter',
        label: 'label.em.admin.emMenu.filter.aclUrl',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'workflowNameFilter',
        label: 'label.em.admin.emMenu.filter.workflowName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"workflowDefinitionKey":"definitionKey"}'
                }
        },
        {
        key: 'crudCodeFilter',
        label: 'label.em.admin.emMenu.filter.crudCode',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emViewCrudState'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'iconCodeFilter',
        label: 'label.em.admin.emMenu.filter.iconCode',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emCssIcon'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.admin.emMenu.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
    {
        key: 'customConfigJsonFilter',
        label: 'label.em.admin.emMenu.filter.customConfigJson',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.em.admin.emMenu.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emMenu'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emMenu.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'menuTypeCode',
        label: 'label.em.admin.emMenu.entity.menuTypeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emMenuType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'crudCode',
        label: 'label.em.admin.emMenu.entity.crudCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emViewCrudState'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"name":"name","i18nMenuName":"menuNameI18n","i18nBreadcrumbName":"breadcrumbNameI18n","iconCode":"icon","menuTypeCode":"menuTypeCode"}'
                }
        },
        {
        key: 'i18nMenuName',
        label: 'label.em.admin.emMenu.entity.i18nMenuName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'i18nBreadcrumbName',
        label: 'label.em.admin.emMenu.entity.i18nBreadcrumbName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'url',
        label: 'label.em.admin.emMenu.entity.url',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baseRequestUrl',
        label: 'label.em.admin.emMenu.entity.baseRequestUrl',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'aclUrl',
        label: 'label.em.admin.emMenu.entity.aclUrl',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'workflowName',
        label: 'label.em.admin.emMenu.entity.workflowName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"workflowDefinitionKey":"definitionKey"}'
                }
        },
        {
        key: 'iconCode',
        label: 'label.em.admin.emMenu.entity.iconCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emCssIcon'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emMenu.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'status',
        label: 'label.em.admin.emMenu.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emMenu.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
        {
            key: 'customConfigJson',
            label: 'label.em.admin.emMenu.entity.customConfigJson',
            sortable: true,
            disabled: false,
            form: {
                type: 'json-params',
                modalMultiSelectedType: 'string'
                }
        }
]

export {EmMenu, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
